import { useLocation } from 'react-router-dom';

import { PageLoader } from '@/components/Loader';
import { NAVIGATION, NAVIGATION_FOOTER, SETTINGS_PAGES, isGroup, type NavEntry } from './navigation';

/** Every page the navigation knows, deepest first, so /settings/offline beats /settings. */
function pages(): { path: string; label: string }[] {
  const flat: { path: string; label: string }[] = [];
  const walk = (entries: readonly NavEntry[]) => {
    for (const entry of entries) {
      if (isGroup(entry)) walk(entry.items);
      else flat.push({ path: entry.path, label: entry.label });
    }
  };
  walk(NAVIGATION);
  walk(NAVIGATION_FOOTER);
  walk(SETTINGS_PAGES);
  return flat.sort((a, b) => b.path.length - a.path.length);
}

const PAGES = pages();

/**
 * While a page's code arrives: "Opening Batches", named from the same
 * navigation the sidebar draws, so the words match the link just pressed.
 * A page the navigation does not list (a prescription opened from the queue)
 * is simply "Opening".
 */
export function RoutePageLoader() {
  const { pathname } = useLocation();
  const page = PAGES.find((p) =>
    p.path === '/' ? pathname === '/' : pathname === p.path || pathname.startsWith(`${p.path}/`),
  );
  return <PageLoader label={page ? `Opening ${page.label}` : 'Opening'} />;
}
